import type { CourseDocument } from '../CourseDocument';
import { createTournamentPinesDocument, tournamentPinesMetadata } from './tournamentPines';
import { createCopperRidgeDocument, copperRidgeMetadata } from './copperRidge';
import { createEmeraldCoastDocument, emeraldCoastMetadata } from './emeraldCoast';
import { createBluewaterBayDocument, bluewaterBayMetadata } from './bluewaterBay';
import { createIronwoodForestDocument, ironwoodForestMetadata } from './ironwoodForest';
import { createGoldenPrairieDocument, goldenPrairieMetadata } from './goldenPrairie';
import { createSummitLakeDocument, summitLakeMetadata } from './summitLake';
import { createRedstoneCanyonDocument, redstoneCanyonMetadata } from './redstoneCanyon';
import { createRoyalHeatherDocument, royalHeatherMetadata } from './royalHeather';
import { createAuroraCliffsDocument, auroraCliffsMetadata } from './auroraCliffs';
import { createBlackOakReserveDocument, blackOakReserveMetadata } from './blackOakReserve';
import { createPelicanShoresDocument, pelicanShoresMetadata } from './pelicanShores';
import { createGlacierPeaksDocument, glacierPeaksMetadata } from './glacierPeaks';
import { createWindhavenLinksDocument, windhavenLinksMetadata } from './windhavenLinks';
import { createCrystalLakesDocument, crystalLakesMetadata } from './crystalLakes';
import { createSandstoneDunesDocument, sandstoneDunesMetadata } from './sandstoneDunes';
import { createStormPointDocument, stormPointMetadata } from './stormPoint';
import { createEagleCrestNationalDocument, eagleCrestNationalMetadata } from './eagleCrestNational';
import { createKingsMoorDocument, kingsMoorMetadata } from './kingsMoor';
import { createChampionsReserveDocument, championsReserveMetadata } from './championsReserve';
export interface BuiltInCourseRegistration {
  id: string;
  name: string;
  description: string;
  tournamentEventId: string;
  holeCount: number;
  totalPar: number;
  totalYardage: number;
  load: () => CourseDocument;
}
export const BUILT_IN_COURSES: readonly BuiltInCourseRegistration[] = [
  {
    ...tournamentPinesMetadata,
    holeCount: 18,
    totalPar: 72,
    totalYardage: 7039,
    load: createTournamentPinesDocument,
  },
  {
    ...copperRidgeMetadata,
    tournamentEventId: copperRidgeMetadata.metadata.tournamentEventId,
    holeCount: 18,
    totalPar: 72,
    totalYardage: 7350,
    load: createCopperRidgeDocument,
  },
  {
    ...emeraldCoastMetadata,
    tournamentEventId: emeraldCoastMetadata.metadata.tournamentEventId,
    holeCount: 18,
    totalPar: 71,
    totalYardage: 7200,
    load: createEmeraldCoastDocument,
  },
  {
    ...bluewaterBayMetadata,
    tournamentEventId: bluewaterBayMetadata.metadata.tournamentEventId,
    holeCount: 18,
    totalPar: 72,
    totalYardage: 7100,
    load: createBluewaterBayDocument,
  },
  {
    ...ironwoodForestMetadata,
    tournamentEventId: ironwoodForestMetadata.metadata.tournamentEventId,
    holeCount: 18,
    totalPar: 70,
    totalYardage: 7000,
    load: createIronwoodForestDocument,
  },
  {
    ...goldenPrairieMetadata,
    tournamentEventId: goldenPrairieMetadata.metadata.tournamentEventId,
    holeCount: 18,
    totalPar: 72,
    totalYardage: 7380,
    load: createGoldenPrairieDocument,
  },
  ...[
    [summitLakeMetadata, 72, 7245, createSummitLakeDocument],
    [redstoneCanyonMetadata, 71, 7180, createRedstoneCanyonDocument],
    [royalHeatherMetadata, 70, 6940, createRoyalHeatherDocument],
    [auroraCliffsMetadata, 72, 7390, createAuroraCliffsDocument],
    [blackOakReserveMetadata, 72, 7235, createBlackOakReserveDocument],
    [pelicanShoresMetadata, 72, 7010, createPelicanShoresDocument],
    [glacierPeaksMetadata, 72, 7155, createGlacierPeaksDocument],
    [windhavenLinksMetadata, 71, 7115, createWindhavenLinksDocument],
    [crystalLakesMetadata, 72, 7250, createCrystalLakesDocument],
    [sandstoneDunesMetadata, 72, 7395, createSandstoneDunesDocument],
    [stormPointMetadata, 71, 7255, createStormPointDocument],
    [eagleCrestNationalMetadata, 72, 7595, createEagleCrestNationalDocument],
    [kingsMoorMetadata, 70, 6950, createKingsMoorDocument],
    [championsReserveMetadata, 72, 7395, createChampionsReserveDocument],
  ].map(([metadata, totalPar, totalYardage, load]) => ({
    ...(metadata as typeof summitLakeMetadata),
    tournamentEventId: (metadata as typeof summitLakeMetadata).metadata.tournamentEventId,
    holeCount: 18,
    totalPar: totalPar as number,
    totalYardage: totalYardage as number,
    load: load as () => CourseDocument,
  })),
];
export const builtInCourseIds = new Set(BUILT_IN_COURSES.map((c) => c.id));
export function loadBuiltInCourse(id: string) {
  return BUILT_IN_COURSES.find((c) => c.id === id)?.load();
}
